import { Trans } from "react-i18next";

const News9 = () => {
    return (
        <Trans
            i18nKey={"Dashboard##news##body##9"}
            components={{
                section: <section />,
                h3: <h3>""</h3>, // fake empty content to avoid warnings
                p: <p />,
                ul: <ul />,
                ol: <ol />,
                li: <li />,
                strong: <strong />
            }}
        />
    );
};

export { News9 };
